<template>
  <div class="workspace-section">
    <div class="workspace" :class="{'disable': isDisable}">

      <div class="c-workspace">

        <AvatarWidget
            :image-key="workspace.avatar"
            :social-avatar="workspace.name"
            image-size="imageSM"
            :full-name-avatar="workspace.textAvatar"
            :alt="workspace.name"
            :title="workspace.name"
        />

        <div class="c-name">
          <span>{{ workspace.company }}</span>
          <span>{{ workspace.url }}</span>
        </div>
        <div class="c-arrow" v-if="withButton">
          <ActionDropdownElement
              v-if="workspace.userRole === 'OWNER'"
              title="Actions"
              :options="deleteWorkspaceActions"
              type="button"
              icon="EllipsisVertical"
              class="actions-icon"
              @change="$emit('deleteWorkspace', workspace.id)"
          />
          <ActionDropdownElement
              v-if="workspace.userRole != 'OWNER'"
              title="Actions"
              :options="leftWorkspaceActions"
              type="button"
              icon="EllipsisVertical"
              class="actions-icon"
              @change="$emit('leftWorkspace', workspace.id)"
          />
        </div>
      </div>
    </div>
    <div class="roles">
      <LucideIcon icon="ShieldCheck"/>
      <span>{{ getWorkspaceRole(workspace) }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from 'vue';
import {ActionDropdownElement} from '@shared/components/elements';

import {type DropdownNs, WorkspaceNs} from '@shared/types';
import AvatarWidget from "@shared/components/widgets/profile/avatar.widget.vue";

export default defineComponent({
  name: 'WorkspaceAccessSection',
  components: {
    AvatarWidget,
    ActionDropdownElement
  },
  emits: ['deleteWorkspace', 'leftWorkspace'],
  props: {
    withButton: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    workspace: {
      type: Object as PropType<WorkspaceNs.Workspace>,
      required: true,
    },

  },
  computed: {
    imageUrl(): string {
      if (this.workspace.avatar) {
        return `${this.workspace.avatar}/imageSM`;
      } else {
        return '';
      }
    },
  },
  data() {
    return {
      /** 0: NotExists | 1:Loading | 2:Loaded */
      imageStatus: 0,

      deleteWorkspaceActions: [
        {
          name: 'Delete Workspace',
          iconType: 'fal',
          icon: 'Trash2',
        },
      ] as DropdownNs.DropdownOptionsItem[],
      leftWorkspaceActions: [
        {
          name: 'Leave Workspace',
          iconType: 'fal',
          icon: 'Trash2',
        },
      ] as DropdownNs.DropdownOptionsItem[],
    };
  },
  beforeMount() {
    if (this.workspace.avatar) {
      this.imageStatus = 2;
      // store.dispatch('actionGetCompanyAvatar', this.workspace.avatar)
      //   .then((response) => {
      //     this.avatarImg = `data:image/jpg;base64,${response}`;
      //     this.imageStatus = 2;
      //   }).catch(() => this.imageStatus = 0);
    }
  },
  methods: {
    onImageError() {
      this.imageStatus = 0;
    },
    getWorkspaceRole(workspace: WorkspaceNs.Workspace) {
      const role = WorkspaceNs.WorkspaceRoleEnum[workspace.userRole];
      if (!role) return '';
      return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
    }
  },
});
</script>

<style lang="scss" scoped>
.workspace-section {
  display: flex;
  margin-bottom: var(--space-16);

  .workspace {
    width: 70%;;
    height: auto !important;
    text-transform: none !important;
    line-height: 20px;
    padding: 10px;
    background-color: var(--card-bg);
    box-shadow: var(--card-shadow);
    border-radius: $br-sm;

    &:hover {
      box-shadow: var(--card-shadow-active);
    }


    &.disable {
      background-color: var(--light-300);
    }

    .c-workspace {
      display: flex;
      gap: var(--space-8);

      .c-name {
        display: flex;
        width: 100%;
        flex-grow: 1;
        text-align: left;
        overflow: hidden;
        outline: none;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        z-index: 1;
        font-size: var(--fs-14);

        span:first-child {
          font-size: var(--fs-14);
          font-weight: 600;
          text-align: left;
          display: inline-block;
          width: 100%;
        }

        span:nth-of-type(2) {
          font-size: var(--fs-12);
          color: var(--text-neutral);
          margin-top: var(--space-negative-2);
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          width: 95%;
        }
      }

      .c-arrow {
        margin-left: auto;
        margin-right: var(--space-6);
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--text-blue);
      }
    }
  }

  .roles {
    font-size: var(--fs-13);
    color: var(--text-neutral);
    width: 30%;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      margin-right: var(--space-8);
    }
  }
}
</style>
